var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        class: _vm.onreload ? "show" : "show",
        style: _vm.onreload ? "display: block; padding-left: 0px;" : "",
        attrs: { tabindex: "-1", role: "dialog" },
        on: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.ACTION()
          },
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c(
            "form",
            {
              staticClass: "modal-content shadow-3",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.ACTION()
                },
              },
            },
            [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "div",
                  {
                    staticClass: "icon icon-shape rounded-3 text-lg me-4",
                    class:
                      "" +
                      (_vm.item.state_id == 25
                        ? "bg-soft-primary text-primary"
                        : _vm.item.revert == true
                        ? "bg-soft-danger text-danger"
                        : "bg-soft-success text-success"),
                  },
                  [
                    _c("i", {
                      class:
                        "" +
                        (_vm.item.state_id == 25
                          ? "fa-solid fa-truck-fast"
                          : _vm.item.revert == true
                          ? "fa-solid fa-truck-fast fa-flip-horizontal"
                          : "fa-solid fa-check"),
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", [
                  _c("h5", { staticClass: "mb-1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.item.state_id == 25
                          ? "Entregar"
                          : _vm.item.revert == true
                          ? _vm.item.state_id == 27
                            ? "Abrir"
                            : "Devolver"
                          : "Completar"
                      ) + " Ruta"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("small", { staticClass: "d-block text-xs text-muted" }, [
                    _vm._v(
                      "¿Realmente desea " +
                        _vm._s(
                          _vm.item.state_id == 25
                            ? "Entregar"
                            : _vm.item.revert == true
                            ? _vm.item.state_id == 27
                              ? "Abrir"
                              : "Devolver"
                            : "Completar"
                        ) +
                        " esta ruta?"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ms-auto" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("div", [
                    _c("p", { staticClass: "text-sm" }, [
                      _vm._v("Ingresa tu contraseña para permitir esta acción"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("v-text-field", {
                      staticClass: "form-control form-control-sm",
                      class: _vm.errors.password ? "is-invalid" : "",
                      attrs: {
                        "append-icon": _vm.type ? "mdi-eye" : "mdi-eye-off",
                        type: _vm.type ? "text" : "password",
                        "hide-details": "",
                      },
                      on: {
                        "click:append": function ($event) {
                          _vm.type = !_vm.type
                        },
                      },
                      model: {
                        value: _vm.password,
                        callback: function ($$v) {
                          _vm.password = $$v
                        },
                        expression: "password",
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.errors.password, function (error, index) {
                      return _c(
                        "small",
                        { key: index, staticClass: "invalid-feedback" },
                        [_vm._v(_vm._s(error))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h btn-primary px-3",
                    attrs: { type: "submit" },
                  },
                  [
                    _vm.count >= 1
                      ? _c(
                          "div",
                          {
                            staticClass: "spinner-border spinner-border-sm",
                            attrs: { role: "status" },
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Loading..."),
                            ]),
                          ]
                        )
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.item.state == 25
                                ? "Entregar"
                                : _vm.item.revert == true
                                ? _vm.item.state_id == 27
                                  ? "Abrir"
                                  : "Devolver"
                                : "Completar"
                            )
                          ),
                        ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h btn-dark px-3",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("onclose")
                      },
                    },
                  },
                  [_vm._v("Cancelar")]
                ),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }